export default {"src":"/_next/static/media/all-premium-inclusive.5c7721a9.svg","height":200,"width":153,"blurWidth":0,"blurHeight":0};